import { Button } from '@willow/shared-web';

import {
  DEFAULT_HOST_LABEL,
  NONE_BODY,
  NONE_STEP_1,
  NONE_STEP_2,
  NONE_TITLE,
  TRY_ANOTHER_EMAIL,
} from './findPortalCopy';
import { FindPortalLayout } from './FindPortalLayout';

import s from './FindPortal.module.scss';

interface Props {
  email: string;
  onTryAnotherEmail: () => void;
}

export const NoMatchScreen = ({ email, onTryAnotherEmail }: Props) => (
  <FindPortalLayout
    testId="find-portal-screen-none"
    documentTitle={NONE_TITLE}
    title={NONE_TITLE}
    description={NONE_BODY}
  >
    <div className={s.infoBox}>
      <ol className={s.steps}>
        <li>{NONE_STEP_1}</li>
        <li>{NONE_STEP_2}</li>
      </ol>
    </div>
    <Button
      size="lg"
      className="w-100"
      innerClassName="justify-content-center"
      data-testid="find-portal-try-another-email"
      onClick={onTryAnotherEmail}
    >
      {TRY_ANOTHER_EMAIL}
    </Button>
    <p className={s.note}>{email || DEFAULT_HOST_LABEL}</p>
  </FindPortalLayout>
);
